import { useState } from 'react';
import { AxiosError } from 'axios';
import { useSnackbar } from 'notistack';
import { IRealEstateEvent } from '../interfaces';
import { saveRealEstateEvent, updateRealEstateEvent } from '../api';

function useCreateOrUpdateRealEstateEvent(
  realEstateGuid: string,
  realEstateEvent: IRealEstateEvent | null,
  onCreateOrUpdate?: (realEstateEventData: IRealEstateEvent) => void,
) {
  const { enqueueSnackbar } = useSnackbar();

  const [state, setState] = useState<{ loading: boolean; error: string | null }>({ loading: false, error: null });

  async function handleCreateOrUpdateRealEstateEvent(realEstateEventData: IRealEstateEvent) {
    const { realEstateEventType, eventEndTime, eventStartTime, ...props } = realEstateEventData;

    try {
      setState({ loading: true, error: null });

      await (realEstateEvent ? updateRealEstateEvent : saveRealEstateEvent)(realEstateGuid, {
        ...props,
        eventEndTime: new Date(eventEndTime).toISOString(),
        eventStartTime: new Date(eventStartTime).toISOString(),
        realEstateEventTypeId: realEstateEventType?.realEstateEventTypeId!,
      });

      if (onCreateOrUpdate) onCreateOrUpdate(realEstateEventData);
    } catch (error) {
      const message = (error as AxiosError).response?.data.message;

      setState({ loading: false, error: message });
      enqueueSnackbar(message, { variant: 'error' });
    } finally {
      setState((prevState) => ({ ...prevState, loading: false }));
    }
  }

  return { handleCreateOrUpdateRealEstateEvent, createOrUpdateRealEstateEventState: state };
}

export default useCreateOrUpdateRealEstateEvent;
